export class PoolAddressesModel {
  public readonly ethSacraPool: string;
  public readonly sacraGemPool: string;

  constructor(ethSacraPool: string, sacraGemPool: string) {
    this.ethSacraPool = ethSacraPool;
    this.sacraGemPool = sacraGemPool;
  }
}
